// extracted by mini-css-extract-plugin
module.exports = {"touchAction":"PlayTime_touchAction__3X6yK","noUserSelect":"PlayTime_noUserSelect__16wjM"};